import { useEffect, useState } from "react";

import { decoColumns } from "./misc/deco-columns";
import useAxios from "@src/utility/hooks/use-axios";
import { useParams } from "react-router-dom";

const usePeople = () => {
    const { clientId, platformId } = useParams();
    const [data, setData] = useState([]);
    const [modalConfig, setModalConfig] =  useState({
        isOpen: false,
        row   : {}
    }); 

    const { axiosInstance, loading } = useAxios({ base: "panel", initialLoader: true });

    const handleModal = (row = {}) => {
        setModalConfig({
            isOpen: !modalConfig.isOpen,
            row
        });
    };

    const getPeoples = async () => {
        const { data } = await axiosInstance.get(`/people/${platformId}/org/${clientId}`);
        setData(data);
    };

    const handleRowActions = async (row, action) => {
        if (action === "delete") {
            await axiosInstance.delete(`/people/${platformId}/${row._id}`);
            getPeoples();
            return;
        }
        handleModal(row);
    }; 

    useEffect(() => {
        getPeoples();
    }, []);

    return {
        loading,
        data,
        columns: decoColumns({ handleRowActions }),
        modalConfig,
        handleModal,
        handleRowActions,
        getPeoples
    };
};

export default usePeople;